














import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { OpeningHours } from '@shared/types/stores';

export default defineComponent({
  name: 'OpeningHours',
  props: {
    openingHours: {
      type: Array as PropType<OpeningHours[]>,
      required: true,
    },
  },
});
